import React from "react";

const StyleContent = React.createContext(null);
export default StyleContent;
